import styled from 'styled-components';
import { BackButton, SubmitButton } from './MultiSubmit.styled';

/** "Only fill blank" action — Back-button look with centred text and modal padding. */
export const GradingBlankButton = styled(BackButton)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

/** "Replace existing" action — Submit-button look with centred text, modal padding, and spacing. */
export const GradingReplaceButton = styled(SubmitButton)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  margin-left: 10px;
`;
